import axios from "axios";

const api = axios.create({
  baseURL: "https://d1zez9d7l5hgkm.cloudfront.net/v1/publicsearchcampaigndata/",
  // baseURL: "http://localhost:8000/v1/publicsearchcampaigndata/",
  headers: {
    "Content-Type": "application/json",
  },
});

export const parseURLParams = (url) => {
  var queryStart = url.indexOf("?") + 1,
    queryEnd = url.indexOf("#") + 1 || url.length + 1,
    query = url.slice(queryStart, queryEnd - 1),
    pairs = query.replace(/\+/g, " ").split("&"),
    parms = {},
    i,
    n,
    v,
    nv;

  if (query === url || query === "") return;

  for (i = 0; i < pairs.length; i++) {
    nv = pairs[i].split("=", 2);
    n = decodeURIComponent(nv[0]);
    v = decodeURIComponent(nv[1]);

    if (!parms.hasOwnProperty(n)) parms[n] = [];
    parms[n].push(nv.length === 2 ? v : null);
  }
  return parms;
};

const apiCall = async (method, endpoint, data = null) => {
  try {
    let response;
    switch (method.toLowerCase()) {
      case "get":
        response = await api.get(endpoint, {
          params: data,
          headers: {
            "Content-Type": "application/json",
          },
        });
        break;
      case "post":
        response = await api.post(endpoint, data);
        break;
      case "put":
        response = await api.put(endpoint, data);
        break;
      case "delete":
        response = await api.delete(endpoint);
        break;
      default:
        throw new Error(`Unsupported HTTP method: ${method}`);
    }
    return response.data;
  } catch (error) {
    console.error("API Call Error:", error);
    throw error;
  }
};

export default apiCall;

export const checkMobile = () => {
  const isMobile = /iPhone|iPad|iPod|Android/i.test(navigator.userAgent);
  if (isMobile) {
    return "mobile";
  } else {
    return "desktop";
  }
};
export const appShareTextString = (text) => {
  // text = text ? text.split("'").join("") : "";
  text = text ? text.split("‘").join("'") : "";
  text = text ? text.split("’").join("'") : "";
  text = text ? text.split("‟").join('"') : "";
  text = text ? text.split("“").join('"') : "";
  text = text ? text.split("❝").join('"') : "";
  text = text ? text.split("❞").join('"') : "";
  text = text ? text.split("”").join('"') : "";
  text = text ? text.split("„").join('"') : "";
  return text;
};
